import { gql } from '@apollo/client';

import META_FRAGMENT from '../fragments/meta';
import TRANSACTION_TYPES_FRAGMENT from '../fragments/services/transactionTypes';
import TRANSACTIONS_FRAGMENT from '../fragments/transactions';

export const GET_TRANSACTIONS = gql`
  ${TRANSACTIONS_FRAGMENT}
  ${TRANSACTION_TYPES_FRAGMENT}
  ${META_FRAGMENT}
  query findTransactions(
    $pagination: PageOptionsDto
    $order: TransactionSortFields
    $query: String
    $withoutNotary: Boolean
    $locationIds: [String!]
    $onlyMine: Boolean
  ) {
    findTransactionEntity(
      pagination: $pagination
      order: $order
      query: $query
      withoutNotary: $withoutNotary
      locationIds: $locationIds
      onlyMine: $onlyMine
    ) {
      data {
        ...TransactionsFragment
        transactionType {
          ...TransactionTypesFragment
        }
        documents {
          id
          details
          files {
            details
            name
            path
            pipeFrom
            id
            status
            size
          }
        }
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const GET_TRANSACTION = gql`
  ${TRANSACTIONS_FRAGMENT}
  query findOneTransactionEntity($id: String) {
    findOneTransactionEntity(id: $id) {
      ...TransactionsFragment
      appointment {
        ...AppointmentsFragment
        labelFiles {
          id
          details
        }
      }
      location {
        id
        name
        address
      }
      documents {
        id
        details
        subType
        files {
          details
          name
          path
          pipeFrom
          id
          status
          size
          type
          extension
        }
      }
    }
  }
`;

export const GET_TRANSACTIONS_MINIMAL = gql`
  query findTransactions(
    $pagination: PageOptionsDto
    $order: TransactionSortFields
    $query: String
    $withoutNotary: Boolean
    $status: trans_status_enum
  ) {
    findTransactionEntity(
      pagination: $pagination
      order: $order
      query: $query
      withoutNotary: $withoutNotary
      status: $status
    ) {
      data {
        id
        reference
        description
        transactionType {
          id
          name
        }
      }
    }
  }
`;
